import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LoginBlockLanguageSwitcher = ({ config }) => {
    const { i18n, t } = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('selectedLanguage') || i18n.language);

    const primaryLang = config.global_dual_language_primary_code || 'en';
    const secondaryLang = config.global_dual_language_secondary_code || 'ar';

    const switchLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('selectedLanguage', lng);
        setSelectedLanguage(lng);
        window.location.reload(); // Reload the page
    };

    useEffect(() => {
        const savedLanguage = localStorage.getItem('selectedLanguage');
        if (savedLanguage) {
            i18n.changeLanguage(savedLanguage);
            setSelectedLanguage(savedLanguage);
        }
    }, [i18n]);

    return (
        <div className="product_catalog_block_language_switcher">
            <div className="product_catalog_block_language_switcher_title">{t("product_catalog_block_language_switcher_title_text")}</div>
            <div className="product_catalog_block_language_switcher_holder">
                <div
                    onClick={() => switchLanguage(primaryLang)}
                    className={`product_catalog_block_language_switcher_button product_catalog_block_language_switcher_primary_text bold pointer ${selectedLanguage === primaryLang ? 'product_catalog_block_language_switcher_button_selected' : ''}`}
                >
                    {t("global_dual_language_primary_name")}
                </div>
                <div
                    onClick={() => switchLanguage(secondaryLang)}
                    className={`product_catalog_block_language_switcher_button product_catalog_block_language_switcher_secondary_text bold pointer ${selectedLanguage === secondaryLang ? 'product_catalog_block_language_switcher_button_selected' : ''}`}
                >
                    {t("global_dual_language_secondary_name")}
                </div>
            </div>
        </div>
    );
};

export default LoginBlockLanguageSwitcher;
